export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11337.13226aea.jpg";